import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { IOperationNotificationResponse } from 'types/api/operationsAimApi.interface'
import { IOpsNotificationsSlice } from 'types/opsNotifications.interface'
import { baseUrl } from 'utils/axios'
import { handleErrors } from 'utils/helpers'

const initialState: IOpsNotificationsSlice = {
  isLoading: false,
  needsYou: [],
}

export const getNeedsYouNotifications = createAsyncThunk(
  'opsNotifications/getNeedsYouNotifications',
  async (_, thunkAPI) => {
    try {
      const resp: AxiosResponse<IOperationNotificationResponse[]> = await baseUrl.get(
        'aim-operations/notifications/needs-you',
      )
      return resp.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

export const markNotificationRead = createAsyncThunk(
  'opsNotifications/markNotificationRead',
  async (id: number, thunkAPI) => {
    try {
      await baseUrl.post(`aim-operations/notifications/${id}/read`)
      await thunkAPI.dispatch(getNeedsYouNotifications())
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

const opsNotificationsSlice = createSlice({
  name: 'opsNotifications',
  initialState,
  reducers: {
    clearOpsNotifications: (state) => {
      state.needsYou = []
    },
  },
  extraReducers: {
    [getNeedsYouNotifications.pending.type]: (state) => {
      state.isLoading = true
    },
    [getNeedsYouNotifications.fulfilled.type]: (
      state,
      { payload }: { payload: IOperationNotificationResponse[] },
    ) => {
      state.isLoading = false
      state.needsYou = payload || []
    },
    [getNeedsYouNotifications.rejected.type]: (state, action) => {
      state.isLoading = false
      handleErrors(action.payload)
    },
    [markNotificationRead.rejected.type]: (state, action) => handleErrors(action.payload),
  },
})

export const { clearOpsNotifications } = opsNotificationsSlice.actions
export default opsNotificationsSlice.reducer
